import styled from "styled-components";
import {GenericSideMenuItemIconBox} from "../generic/generic-side-menu-item-icon.box";

export const DepositSideMenuItemIconDefaultBox = styled(GenericSideMenuItemIconBox)`
`;
